import { Microfrontend } from '@thoughtspot/microfrontends';
import { loadMicroFrontendComponent } from './microfrontend-wrapper';
import { initMicroFrontend } from './microfrontends.util';

enum EurekaComponents {
    EurekaPage = 'EurekaPage',
    EurekaMainSearchBar = 'EurekaMainSearchBar',
    CreateAiAnswerSearchBar = 'CreateAiAnswerSearchBar',
    DataPanelTopLiveboards = 'DataPanelTopLiveboards',
    DataPanelTopAnswers = 'DataPanelTopAnswers',
}

export const EurekaPage = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.EurekaPage,
);
export const EurekaMainSearchBar = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.EurekaMainSearchBar,
);

export const DataPanelTopAnswers = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.DataPanelTopAnswers,
);

export const DataPanelTopLiveboards = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.DataPanelTopLiveboards,
);

export const CreateAiAnswerSearchBar = loadMicroFrontendComponent(
    Microfrontend.EUREKA,
    EurekaComponents.CreateAiAnswerSearchBar,
);

initMicroFrontend(Microfrontend.EUREKA);
